import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material';
import AuthApp from './auth-app';

const theme = createTheme({
    palette: { mode: 'dark' },
    breakpoints: { values: { xs: 0, sm: 640, md: 768, lg: 1024, xl: 1280, xxl: 1536 } },
});

const csrfToken = document.querySelector('#data-csrf-token')?.textContent?.trim() || '';

const root = ReactDOM.createRoot(document.querySelector('#app'));

root.render(
    <ThemeProvider theme={theme}>
        <BrowserRouter>
            <AuthApp csrfToken={csrfToken} />
        </BrowserRouter>
    </ThemeProvider>
);
